import { Phone, MapPin } from "lucide-react";
import { LeadForm } from "@/components/forms/LeadForm";
import { MaskLines, Reveal } from "@/components/motion/Reveal";
import { COMPANY } from "@/data/site";

export const LeadSection = ({ index = "05", source = "lead-form", interest = "" }) => (
  <section id="get-started" className="relative overflow-hidden border-t border-white/5 py-28 lg:py-40" data-testid="lead-section">
    <div className="pointer-events-none absolute -left-40 top-20 h-[50vh] w-[50vh] rounded-full bg-volt/10 blur-[140px]" />
    <div className="container-x relative grid gap-16 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal><p className="eyebrow"><span className="text-slate-500">{index} —</span> Get Started</p></Reveal>
        <h2 className="mt-5 font-display text-3xl font-bold leading-[1.02] tracking-tight text-white sm:text-4xl lg:text-5xl">
          <MaskLines onView lines={["Find the Right", "Equipment for", "Your Location"]} />
        </h2>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-md text-base leading-relaxed text-slate-400">Share a few details and we'll recommend equipment — and the partnership option — that fits your space, customers, and goals.</p>
          <p className="mt-4 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500"><span className="h-1.5 w-1.5 rounded-full bg-volt" /> Free consultation · No obligation</p>
          <div className="mt-10 space-y-4 text-sm">
            <a href={COMPANY.tel} className="flex items-center gap-3 text-white transition-colors hover:text-volt" data-testid="lead-section-phone"><Phone className="h-4 w-4 text-volt" /> {COMPANY.phone}</a>
            <p className="flex items-center gap-3 text-slate-400"><MapPin className="h-4 w-4 text-volt" /> {COMPANY.street}, {COMPANY.city}</p>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.1} className="lg:col-span-7">
        <div className="rounded-[28px] border border-white/10 bg-ink-800/60 p-6 backdrop-blur-xl sm:p-10">
          <LeadForm source={source} presetInterest={interest} />
        </div>
      </Reveal>
    </div>
  </section>
);
